import { httpGet } from '../utils'

export default {
  search (cb, name) {
    httpGet(`/api/search/name/${name}`, cb)
    /*
    setTimeout(() => {
      cb.success({
        body: {
          contacts: [],
          forms: [],
          orgs: [],
          projects: [],
          activities: [{
            'id': 'caqox9g48omp21rydmpdvew7n5qkz3lm',
            'title': '哈哈哈哈',
            'signed_up_user_count': 4,
            'signed_in_user_count': 0,
            'address': '哈哈哈',
            'publish_time': 1497575734
          },
          {
            'id': 'ca43en47pzywmr8g01z61vkxlq2o953p',
            'title': 'gogogog',
            'signed_up_user_count': 9,
            'signed_in_user_count': 0,
            'address': '北京北京啦',
            'publish_time': 1497702523
          }]
        }
      })
    }, 100)
    */
  }
}



// WEBPACK FOOTER //
// ./src/api/lxm/search.js